import { render, staticRenderFns } from "./StructBuild.vue?vue&type=template&id=32c9291a"
import script from "./StructBuild.vue?vue&type=script&lang=js"
export * from "./StructBuild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports